import './alert.scss'

export default (props) => {
    const iconType = props.iconType || (props.type === 'error' || props.type === 'warning') ? 'exclamation-mark-circled' : (props.type === 'success' ? 'checkmark-circled' : 'letter-i-circled')
    
    return (
        <p className={`alert ${props.type || 'default'} ${props.className}`} role="alert">
            <span className="alert-icon alert-icon-variant">
                {!props.iconHidden &&
                   <span className="icon " style={{ WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${iconType}.svg)`, maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${iconType}.svg)`, color: "currentColor" }}>
                   </span>
                }
            </span>
            <span className="alert-text">{props.label && <label className='text lead medium'>{props.label}</label>}
                {props.children}
            </span>
            {/*props.hasControl &&
                <span className="control">
                    <button className="icon-button secondary medium" onclick="" title="Icon Button">
                        <span className="icon " style={{ WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)", color: "currentColor" }}>
                        </span>
                    </button>
                </span>
            */}

        </p>
    )
}